import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Arrow: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3638 13.447C16.0709 13.7399 15.5961 13.7399 15.3032 13.447L10.0002 8.14401L4.69716 13.447C4.40427 13.7399 3.92939 13.7399 3.6365 13.447C3.34361 13.1541 3.34361 12.6793 3.6365 12.3864L9.46983 6.55302C9.76273 6.26013 10.2376 6.26013 10.5305 6.55302L16.3638 12.3864C16.6567 12.6793 16.6567 13.1541 16.3638 13.447Z"
        fill="#748399"
      />
    </svg>
  )
}

Arrow.displayName = 'Arrow'

export default withIcon(Arrow)
